import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=6f6ff382&scoped=true"
import script from "./offline.vue?vue&type=script&lang=js"
export * from "./offline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ff382",
  null
  
)

export default component.exports